export enum RewardSymbol {
  ALL = 'all',
  MERIT_ALL = 'merit-all',
  PROTOCOL_ALL = 'protocol-all',
}

export enum ControllerIdentifier {
  MERIT_REWARD = 'MERIT_REWARD',
}
